import React__default, { useMemo } from 'react';
import { useSlate } from 'slate-react';
import { ToolbarContext } from './context.mjs';
import { useEnabledToolbarEntries } from './hooks/useEnabledToolbarEntries.mjs';
import { Toolbar as Toolbar$1, Group, Section } from '../ToolbarUI/Toolbar.mjs';
import { Item } from '../ToolbarUI/components/Item/Item.mjs';
import { Button } from './components/Button/Button.mjs';
import { Dropdown } from '../ToolbarUI/components/Dropdown/Dropdown.mjs';

function Toolbar({
  entries,
  plugins,
  onAction,
  disabled = false
}) {
  const editor = useSlate();
  const {
    children: value,
    marks,
    selection
  } = editor;
  const context = useMemo(() => ({
    onActionAnyItem: onAction
  }), [onAction]);
  const enabledToolbarEntries = useEnabledToolbarEntries(entries, plugins);
  if (!enabledToolbarEntries.length) {
    return null;
  }
  return /*#__PURE__*/React__default.createElement(Toolbar$1, null, /*#__PURE__*/React__default.createElement(ToolbarContext.Provider, {
    value: context
  }, enabledToolbarEntries.map((group, index) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  React__default.createElement(Group, {
    key: `Group-${index}`
  }, group.map((section, index) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  React__default.createElement(Section, {
    key: `Section-${index}`
  }, section.map(({
    component: Component,
    plugin
  }, index) =>
  /*#__PURE__*/
  // eslint-disable-next-line react/no-array-index-key
  React__default.createElement(Item, {
    key: `${plugin.type}-${index}`
  }, /*#__PURE__*/React__default.createElement(Component, {
    editor: editor,
    value: value,
    marks: marks,
    selection: selection,
    plugin: plugin,
    disabled: disabled
  })))))))));
}
Toolbar.Button = Button;
Toolbar.Dropdown = Dropdown;

export { Toolbar };
